<mat-toolbar color="primary">
    <span></span>
    <span>Facturación Rest-Cube</span>
    <span></span>
</mat-toolbar>
<br>
<br>
<br>
<br>
<router-outlet></router-outlet>